export enum NumerationType {
    BUDGETS = 'BUDGETS',
    TS = 'TS',
}
